import React from "react";
import { STYLE_TYPE } from "../../../config/constants";
import blockHTML from "../../../utils/blockHTML";

export const styleToHTML = (style) => {
  switch (style.toLowerCase()) {
    case STYLE_TYPE.BOLD:
      return <strong />;

    case STYLE_TYPE.ITALIC:
      return <em />;

    default:
      return <span />;
  }
};

export const blockToHTML = (extras, isClient) => (block) => {
  const html = blockHTML[block.type.toLowerCase()];

  switch(typeof html) {
    case "undefined":
      return blockHTML["default"];

    case "function":
      return html(block, extras, isClient);

    default:
      return html;
  }
};



// WEBPACK FOOTER //
// ./src/components/Library/StoryBody/conversionHelpers.js